export const MOD_VAR_LOC_ROUTE = `/:model/:variation/:locale`;
export const LANDING_ROUTE = `${MOD_VAR_LOC_ROUTE}/landing`;
export const SECTION_ROUTE = `${MOD_VAR_LOC_ROUTE}/:sectionID`;
export const PAGE_ROUTE = `${SECTION_ROUTE}/:pageID`;
